import { render, staticRenderFns } from "./AdminInvoiceActions.vue?vue&type=template&id=a9b3b35a&"
import script from "./AdminInvoiceActions.vue?vue&type=script&lang=ts&"
export * from "./AdminInvoiceActions.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports